(function () {
    // find this section from the script tag
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`[id="${sectionID}"]`);

    // subscribing shows 50% off the subscription price, the discount itself is set up in Shopify
    const SUBSCRIPTION_MULTIPLIER = 0.5;

    // get the data liquid serialized into the section
    const product = JSON.parse(section.querySelector(".productV28JSON").textContent);
    const variantColors = JSON.parse(section.querySelector(".productV28VariantColorsJSON").textContent);
    const subscriptionAppID = JSON.parse(section.querySelector(".productV28SubscriptionAppIDJSON").textContent);
    const cartNote = JSON.parse(section.querySelector(".productV28CartNoteJSON").textContent);

    // the selling plans that belong to the subscription app
    const appSellingPlans = product.selling_plan_groups
        .filter(group => group.app_id === subscriptionAppID)
        .flatMap(group => group.selling_plans);

    // state
    let activeVariant = JSON.parse(section.querySelector(".productV28VariantJSON").textContent);

    // elements
    const atc = section.querySelector(".productV28FormATC");
    const atcText = section.querySelector(".productV28FormATCText");
    const atcPrice = section.querySelector(".productV28FormATCPrice");

    /********************* Helpers *********************/

    // the first order price, 50% off the subscription price
    function subscriptionPrice(allocation) {
        return Math.round(allocation.price * SUBSCRIPTION_MULTIPLIER);
    }

    // the active variant's allocation for the subscription app's plan
    function subscriptionAllocation() {
        return activeVariant.selling_plan_allocations.find(allocation => {
            return appSellingPlans.some(plan => plan.id === allocation.selling_plan_id);
        });
    }

    function isSubscription() {
        return !!section.querySelector(`.productV28FormPlansLabelInput[value="sub"]:checked`);
    }

    // set the text of every element matching the selector
    function setText(selector, text) {
        section.querySelectorAll(selector).forEach(element => {
            element.textContent = text;
        });
    }

    /********************* Swipers *********************/

    // build a gallery's swipers the first time it's shown
    const builtWraps = new WeakSet();

    function buildGallery(wrap) {
        if (builtWraps.has(wrap)) {
            return;
        }
        builtWraps.add(wrap);

        const thumbsSwiper = new Swiper(wrap.querySelector(".productV28VisualThumbs"), {
            slidesPerView: 6,
            spaceBetween: 10,
            loop: true,
            breakpoints: {
                800: {
                    spaceBetween: 23,
                },
            },
        });

        new Swiper(wrap.querySelector(".productV28VisualSwiper"), {
            slidesPerView: 1,
            spaceBetween: 6,
            loop: true,
            autoHeight: true,
            navigation: {
                nextEl: wrap.querySelector(".productV28VisualSwiperNext"),
                prevEl: wrap.querySelector(".productV28VisualSwiperPrev"),
            },
            breakpoints: {
                800: {
                    spaceBetween: 23,
                },
            },
            thumbs: {
                swiper: thumbsSwiper,
            },
        });
    }

    section.querySelectorAll(".productV28VisualWrap.active").forEach(buildGallery);

    // quotes rotate on their own
    const quotes = section.querySelector(".productV28HeaderQuotes");
    if (quotes) {
        new Swiper(quotes, {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            speed: 4000,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
        });
    }

    /********************* Update Product *********************/

    // repaint everything that depends on the active variant and purchase type
    function updateProduct() {
        // find the variant matching the checked options
        if (product.variants.length > 1) {
            const options = [];
            section.querySelectorAll(".productV28FormOptionsItem").forEach(group => {
                options.push(group.querySelector(".productV28FormOptionsItemValuesLabelInput:checked").value);
            });

            activeVariant = product.variants.find(variant => {
                return JSON.stringify(variant.options) === JSON.stringify(options);
            });
        }

        // no variant for this combination
        if (!activeVariant) {
            atc.disabled = true;
            atcText.textContent = "Not Available";
            return;
        }

        // flavor choice next to the label
        section.querySelectorAll(".productV28FormOptionsItemLabelChoice").forEach(choice => {
            choice.textContent = activeVariant.options[0];
            choice.style.color = variantColors[activeVariant.id];
        });

        updatePrices();
        updateGallery();

        // swap icon text between subscription and one-time
        section.querySelectorAll(".productV28FormIconsItemText.sub").forEach(subText => {
            subText.classList.toggle("active", isSubscription());
            subText.previousElementSibling.classList.toggle("active", !isSubscription());
        });

        updateATC();

        // keep the selection on refresh
        const url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // purchase type prices, offer box and atc price
    function updatePrices() {
        const allocation = subscriptionAllocation();

        // one-time is the normal price, compared against the compare at price when there is one
        let oneTimeCompare = "";
        if (activeVariant.compare_at_price > activeVariant.price) {
            oneTimeCompare = price(activeVariant.compare_at_price, true);
        }
        setText(".productV28FormPlansLabelBodyHeaderPriceCompare.once", oneTimeCompare);
        setText(".productV28FormPlansLabelBodyHeaderPriceReal.once", price(activeVariant.price, true));

        // subscription is 50% off the plan price, compared against the one-time price
        let atcAmount = activeVariant.price;
        if (allocation) {
            const sellingPlan = appSellingPlans.find(plan => plan.id === allocation.selling_plan_id);

            setText(".productV28FormPlansLabelBodyHeaderPriceCompare.sub", price(activeVariant.price, true));
            setText(".productV28FormPlansLabelBodyHeaderPriceReal.sub", price(subscriptionPrice(allocation), true));
            setText(".productV28FormPlansLabelBodyOffer .offerPrice", price(subscriptionPrice(allocation), true));
            setText(".productV28FormPlansLabelBodyOffer .offerSubPrice", price(allocation.price, true));
            setText(".productV28FormPlansLabelBodyBulletsItemText .frequency", sellingPlan.name);

            if (isSubscription()) {
                atcAmount = subscriptionPrice(allocation);
            }
        }

        atcPrice.textContent = price(atcAmount, true);

        // offer percent is pulled from the selected size's savings text
        const sizeInput = section.querySelector(".productV28FormOptionsItem.size .productV28FormOptionsItemValuesLabelInput:checked");
        let offerPercent = "";
        if (sizeInput) {
            const percentMatch = sizeInput.dataset.savings.match(/\d+(\.\d+)?%/);
            if (percentMatch) {
                offerPercent = percentMatch[0];
            }
        }
        setText(".productV28FormPlansLabelBodyOffer .offerPercent", offerPercent);
    }

    // show the gallery for the active variant and purchase type
    function updateGallery() {
        if (section.querySelector(".productV28VisualWrap.default")) {
            return;
        }

        // fall back to the one-time gallery when there's no subscription one
        let galleryType = "once";
        if (isSubscription()) {
            galleryType = "sub";
        }
        const wrap = section.querySelector(`.productV28VisualWrap.${galleryType}[data-id="${activeVariant.id}"]`)
            || section.querySelector(`.productV28VisualWrap.once[data-id="${activeVariant.id}"]`);
        if (!wrap) {
            return;
        }

        section.querySelector(".productV28VisualWrap.active")?.classList.remove("active");
        wrap.classList.add("active");
        buildGallery(wrap);
    }

    // enable the atc only when the selection can be bought
    function updateATC() {
        const hasPlans = !!section.querySelector(".productV28FormPlans");

        if (hasPlans && isSubscription() && !subscriptionAllocation()) {
            atc.disabled = true;
            atcText.textContent = "Subscription Unavailable";
            return;
        }

        if (!activeVariant.available) {
            atc.disabled = true;
            atcText.textContent = "Sold Out";
            return;
        }

        atc.disabled = false;
        atcText.textContent = "Add To Cart";
    }

    // repaint on any option or purchase type change
    section.querySelectorAll(".productV28FormOptionsItemValuesLabelInput, .productV28FormPlansLabelInput").forEach(input => {
        input.addEventListener("change", updateProduct);
    });

    /********************* Add To Cart *********************/

    // add the active variant with its attributes and selling plan
    atc.addEventListener("click", async function () {
        this.classList.add("loading");

        const item = {
            id: activeVariant.id,
            quantity: 1,
            properties: {},
        };

        if (this.dataset.discountKit) {
            item.properties._discount_kit = this.dataset.discountKit;
        }

        if (cartNote) {
            item.properties["Please Note"] = cartNote;
        }

        if (isSubscription()) {
            item.selling_plan = subscriptionAllocation().selling_plan_id;
        }

        await addProduct({ items: [item] });

        this.classList.remove("loading");
    });

    /********************* Shipping Cutoff *********************/

    // count down to today's shipping cutoff, or tomorrow's once it's passed
    const shipping = section.querySelector(".productV28FormShipping");
    if (shipping) {
        const cutoffHour = parseInt(shipping.dataset.cutoff);
        const cutoffText = shipping.querySelector(".productV28FormShippingOrderCutoff");

        function renderCutoff() {
            const now = new Date();
            let secondsLeft = (cutoffHour - now.getHours()) * 3600 - (now.getMinutes() * 60 + now.getSeconds());
            if (secondsLeft < 0) {
                secondsLeft += 24 * 3600;
            }

            const hours = Math.floor(secondsLeft / 3600);
            const minutes = Math.floor((secondsLeft % 3600) / 60);
            cutoffText.textContent = `${hours} hrs ${minutes} mins`;
        }

        renderCutoff();
        setInterval(renderCutoff, 1000);
    }

    /********************* Landing Page Links *********************/

    // links to #product scroll to the form, offset so it isn't flush to the top
    document.querySelectorAll(`a[href="#product"]`).forEach(link => {
        link.addEventListener("click", function (event) {
            event.preventDefault();
            const top = section.querySelector(".productV28Form").getBoundingClientRect().top + window.scrollY - 120;
            window.scrollTo({ top: top, behavior: "smooth" });
        });
    });

    /********************* Start *********************/

    // off product pages the variant param isn't applied by Shopify, so check its options here
    const urlVariantID = parseInt(new URLSearchParams(window.location.search).get("variant"));
    const urlVariant = product.variants.find(variant => variant.id === urlVariantID);
    if (!window.location.pathname.includes("/products/") && urlVariant) {
        section.querySelectorAll(".productV28FormOptionsItem").forEach((group, index) => {
            group.querySelectorAll(".productV28FormOptionsItemValuesLabelInput").forEach(input => {
                if (input.value === urlVariant.options[index]) {
                    input.checked = true;
                }
            });
        });
    }

    // first paint
    updateProduct();
}());
